import { z } from 'zod'

import { fetchJson } from '@/api/client'
import type { AgeBand, StoryTopic } from '@/api/stories'
import type { StoryGenerationMode } from '@/schema/settings'

export interface CastSuggestionRequest {
  prompt: string
  age_band: AgeBand
  generation_mode: StoryGenerationMode
  world?: string
  topic?: StoryTopic
  learning_subject?: string
  learning_objective_id?: string
  learning_objective_revision?: number
}

export const CastSuggestionResult = z.object({
  cast: z.array(z.object({
    uid: z.string().min(1),
    name: z.string(),
    thumb_url: z.string().nullable(),
    kind: z.enum(['person', 'animal', 'bird', 'fish', 'creature', 'object']).nullable(),
    role: z.enum(['hero', 'friend']),
    speaks: z.boolean(),
    reason: z.string().min(1),
  })).min(1).max(3),
  generation_mode: z.enum(['bones', 'spritesheet']),
  model: z.string(),
  source: z.literal('ai'),
})
export type CastSuggestionResult = z.infer<typeof CastSuggestionResult>

export function startCastSuggestion(body: CastSuggestionRequest): Promise<{ job_id: number }> {
  return fetchJson('/api/stories/suggest-cast', { method: 'POST', body })
}
